import { createSlice } from '@reduxjs/toolkit';
import { onInputChangeHandler } from '../utils/helper';

type FieldType = 'Text' | 'Number' | 'Date' | 'Dropdown' | 'Checkbox';

interface DropdownOptions {
  label: string;
  value: string;
}

export interface DynamicClaimsApiFields {
  source_type: string;
  field_name: string;
  is_mandatory: boolean;
  field_type: FieldType;
  options: DropdownOptions[] | null;
  label: null;
  additional_details: any;
}

const initialState = {
  clients: [],
  selectedClient: undefined,
  products: [],
  selectedProduct: undefined,
  members: [],
  selectedMember: undefined,
  selectedFamilyMember: undefined,
  syncStatus: false,
  dynamicClaimsApiFields: [] as DynamicClaimsApiFields[],
  claimManagers: [],
  apiIntimation: false,
  errorMessage: {},
};

const addClaimSlice = createSlice({
  name: 'addClaim',
  initialState,
  reducers: {
    setClients: (state, action) => {
      state.clients = action.payload;
      state.products = initialState?.products;
      state.selectedProduct = initialState?.selectedProduct;
      state.syncStatus = false;
      state.dynamicClaimsApiFields = initialState?.dynamicClaimsApiFields;
      state.members = initialState?.members;
      state.selectedMember = initialState?.selectedMember;
      state.selectedFamilyMember = initialState?.selectedFamilyMember;
    },
    setSelectedClient: (state, action) => {
      state.selectedClient = action.payload;
    },
    setProducts: (state, action) => {
      state.products = action.payload;
      state.syncStatus = false;
      state.dynamicClaimsApiFields = initialState?.dynamicClaimsApiFields;
      state.members = initialState?.members;
      state.selectedMember = initialState?.selectedMember;
      state.selectedFamilyMember = initialState?.selectedFamilyMember;
    },
    setSelectedProduct: (state, action) => {
      state.selectedProduct = action.payload;
    },
    setMembers: (state, action) => {
      state.members = action.payload;
      state.selectedFamilyMember = initialState?.selectedFamilyMember;
    },
    setSelectedMember: (state, action) => {
      state.selectedMember = action.payload;
    },
    setSelectedFamilyMember: (state, action) => {
      state.selectedFamilyMember = action.payload;
    },
    setSyncStatus: (state, action) => {
      state.syncStatus = action.payload;
    },
    setDynamicClaimsApiFields: (state, action) => {
      state.dynamicClaimsApiFields = action.payload;
    },
    setClaimManagers: (state, action) => {
      state.claimManagers = action.payload;
    },
    setApiIntimation: (state, action) => {
      state.apiIntimation = action.payload;
    },
    setErrorMessage: (state, action) => {
      state.errorMessage = action.payload;
    },
    reset: (state) => {
      return {
        claimManagers: state.claimManagers,
        clients: [],
        selectedClient: undefined,
        products: [],
        selectedProduct: undefined,
        members: [],
        selectedMember: undefined,
        selectedFamilyMember: undefined,
        syncStatus: false,
        dynamicClaimsApiFields: [],
        apiIntimation: false,
        errorMessage: {},
      };
    },
  },
});

export const addClaimActions = addClaimSlice.actions;
export default addClaimSlice.reducer;
